import { render, staticRenderFns } from "./pre.vue?vue&type=template&id=4631d885&scoped=true"
import script from "./pre.vue?vue&type=script&lang=js"
export * from "./pre.vue?vue&type=script&lang=js"
import style0 from "./pre.vue?vue&type=style&index=0&id=4631d885&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4631d885",
  null
  
)

export default component.exports